import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { setToken, setLoading } from "../services/auth/authSlice";
import { AppDispatch } from "../app/store";

const useUpdateAuthToken = () => {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const updateToken = async () => {
      dispatch(setLoading(true));
      try {
        const accessToken = await getAccessTokenSilently();
        dispatch(setToken(accessToken));
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error("Error getting the access token", error);
        }
        dispatch(setToken(null));
      } finally {
        dispatch(setLoading(false));
      }
    };

    updateToken();
  }, [getAccessTokenSilently, dispatch]);
};

export default useUpdateAuthToken;
